import { EContactTypeV2, EServiceType } from './common';
import { BillingPolicyType } from './paymentSetup';

export enum EventStatus {
    CONFIRMED = 'confirmed',
    ACCEPTED = 'accepted',
    DECLINED = 'declined',
    NEEDSACTION = 'needsAction',
}

export enum EntryPointType {
    VIDEO = 'video',
    PHONE = 'phone',
    MORE = 'more',
}

export enum ReminderOverrideMethod {
    EMAIL = 'email',
    POPUP = 'popup',
}

export type EventUser = {
    email: string;
};

export type EventAttendee = {
    email: string;
    displayName?: string;
    self?: true;
    organizer?: true;
    responseStatus?: EventStatus;
};

export type EventTime = {
    dateTime: string; //'2022-12-28T08:15:00+08:00',
    timeZone: string; //'America/Los_Angeles'
};

// {
//     "entryPointType": "video",
//     "uri": "https://us06web.zoom.us/j/83815658913?pwd=Ym5FUUIwa2x0Y0VtL000OW5jdDdXZz09",
//     "label": "us06web.zoom.us/j/83815658913?pwd=Ym5FUUIwa2x0Y0VtL000OW5jdDdXZz09",
//     "meetingCode": "83815658913",
//     "passcode": "620712"
//   },

export type EntryPoint = {
    entryPointType: EntryPointType;
    uri?: string;
    label?: string;
    meetingCode?: string;
    passcode: string;
};

export type ReminderOverride = {
    method: ReminderOverrideMethod;
    minutes: number;
};
export interface Event {
    kind?: string;
    etag?: string;
    location?: string;
    colorId?: string;
    color?: string;
    description: string;
    id: string;
    status?: EventStatus;
    htmlLink?: string;
    created?: string; //'2022-11-25T19:55:49.000Z',
    updated?: string; //'2022-12-26T07:38:06.385Z',
    summary: string;
    recurrence?: string[];
    creator?: EventUser;
    organizer?: EventUser;
    start: EventTime;
    end: EventTime;
    serviceSpecialty?: string;
    recurringEventId?: string;
    originalStartTime?: EventTime;
    iCalUID?: string;
    sequence?: number;
    appointmentStatus?: EScheduleStatusValue,
    attendees?: EventAttendee[];
    scheduledBy?: EScheduledBy, // "provider-scheduled",
    eventType?: string;
    providerId?: number,
    channelId?: string,
    serviceId?: string,
    duration?: number,
    meetingLink?: string,
    patientName?: string,
    patientPhone?: string,
    sendForm?: string,
    type?: 'appointment' | 'blocker' | 'google',
    isSample?: boolean;
    isProtected?: boolean;
    divId?: string;
    clientId?: number;
}

export interface EventWithTimeOverlap extends Event {
    timeOverlapKeys: string[]
}

export type GoogleColor = {
    id: string;
    background: string //'#ac725e',
    foreground: string //'#1d1d1d'
};

export type Color = {
    id: number,
    type: 'COLOR',
    dictKey: string,
    content: string,
};

// {
//     "start": "2023-01-05T09:00:00.000-07:00",
//     "end": "2023-01-05T17:00:00.000-07:00",
//     "providerId": null,
//     "eventId": "2kep3qjcqu11nfum4ffg0otug4_20230105T160000Z",
//     "channelId": null,
//     "serviceId": null,
//     "duration": null,
//     "meetingLink": null,
//     "patientName": null,
//     "patientPhone": null,
//     "sendForm": null,
//     "colorId": null,
//     "description": "A chance to hear more about Google's developer products.",
//     "email": [
//       "youming.tang@helloklarity.com",
//       "xiaocong.liu@helloklarity.com"
//     ],
//     "location": "800 Howard St., San Francisco, CA 94103",
//     "recurrence": null,
//     "summary": "Test Event -Xiaocong",
//     "timeZone": null
//   },
export type ServerEvent = {
    start: string,
    end: string,
    eventId: string,
    colorId?: string,
    description: string,
    email?: string[],
    location?: string,
    recurrence?: string;
    summary: string,
    timeZone: string,
    providerId?: number,
    channelId?: string,
    serviceId?: string,
    serviceName?: string,
    duration?: number,
    meetingLink?: string,
    patientName?: string,
    patientPhone?: string,
    sendForm?: string,
};
// [
//     {
//         label: 'Does not repeat',
//         value: '1',
//     },
//     {
//         label: 'Daily',
//         value: '2',
//     },
//     {
//         label: `Weekly on ${day.format('dddd')}`, //Weekly on Friday
//         value: '3',
//     },
//     {
//         label: `Monthly on the first ${day.format('dddd')}`, //Monthly on the first Friday
//         value: '4',
//     },
//     {
//         label: `Monthly on the ${day.format('DD')}`, //Monthly on the 6th
//         value: '5',
//     },
//     {
//         label: 'Every weekday (Monday to Friday)',
//         value: '6',
//     },
// ];
export enum RecurringType {
    NOT_REPEAT = 'NOT_REPEAT',
    DAILY = 'DAILY',
    WEEKLY = 'WEEKLY',
    MONTHLY_ON_FIRST_WEEKDAY = 'MONTHLY_ON_FIRST_WEEKDAY',
    MONTHLY_ON_DATE = 'MONTHLY_ON_DATE',
    WEEKDAY = 'WEEKDAY',
}

export type TServerSimpleCalendarEvent = {
    id: number,
    startAt: string, //"2025-03-30T16:00:00Z",
    endAt: string, //"2025-03-30T16:30:00Z",
    title: string, //"Psychiatric & Mental Health: New patient initial visit",
    scheduledBy?: EScheduledBy, // "provider-scheduled",
    recurrenceRule: string | null,
    appointmentStatus?: EScheduleStatusValue | null,
    calendarColor?: string | null,
    serviceSpecialty?: string,
    clientId?: number,
    isSample?: boolean,
};

export enum EScheduledBy {
    KLARITY_BOOKED = 'klarity-booked',
    PROVIDER_SCHEDULED = 'provider-scheduled',
}

export enum EScheduleStatusLabel {
    SCHEDULED = 'Scheduled',
    SHOWED = 'Showed',
    PATIENT_NO_SHOW = 'Patient no show',
    PATIENT_CANCELED = 'Patient canceled',
    PATIENT_LATE_CANCELED = 'Patient late canceled',
    PROVIDER_CANCELED = 'Provider canceled',
}

export enum EScheduleStatusValue {
    SCHEDULED = 'scheduled',
    SHOWED = 'showed',
    PATIENT_NO_SHOW = 'patient-no-show',
    PATIENT_CANCELED = 'patient-canceled',
    PATIENT_LATE_CANCELED = 'patient-late-canceled',
    PROVIDER_CANCELED = 'provider-canceled',
}

export type TProviderAppointmentCancelInfo = {
    id: number,
    appointmentId: number,
    canceledType: string
    canceledReason?: string,
    otherReason?: string,
    messageToPatient?: string,
    manualReason?: string,
    createdAt?: null,
    updatedAt?: null,
    isDeleted?: boolean,
    deletedAt?: null,
    confirmCharge?: boolean,
};

export type TProviderAppointmentBilling = {
    id: number,
    appointmentId: number,
    providerId: number,
    clientId: number,
    klarityUserId: number,
    chargeType: BillingPolicyType | string, // "NO_SHOW/LATE_CANCELLATION/RESCHEDULE",
    relationId: number,
    billingStatus: string, //"PENDING/PROCESSING/SUCCEEDED/FAILED/NOT_READY",
    amountCents: number,
    stripePaymentIntentId: string, //"stripePaymentIntentId_f3df8ca45114",
    stripeChargeId: string, // "stripeChargeId_f5342611542f",
    errorCode: string, // "errorCode_e0d5eb7443a7",
    errorMessage: string, //"errorMessage_288fa1d5e454"
};

export type TServerCalendarAppointmentEventDetail = {
    id?: number, // 8,
    appointmentName: string, // "Annual Check-up-9-9-9?",
    clientId: number,
    startAt: string, // "2025-03-29T10:00:00Z",
    endAt: string, // "2025-03-29T10:30:00Z",
    createdAt: string,//
    duration: number,
    //video, in-person, telephone
    contactType?: EContactTypeV2,
    externalVideoLink?: string,
    notes?: string,
    reason?: string,
    scheduledBy?: EScheduledBy, // "provider-scheduled",
    serviceType?: EServiceType | string,
    serviceSpecialty?: string, //"Family Medicine",
    location?: string, //"Video visit",
    appointmentStatus?: EScheduleStatusValue, //"",
    appointmentStatusChangedAt?: null | string,
    providerConfirm?: boolean,
    providerConfirmAt?: null | string,
    clientConfirm?: boolean,
    clientConfirmAt?: null | string,
    serviceState?: string,
    serviceId?: number,
    calendarColor?: string,
    messageToPatient?: string,
    isSample?: boolean,

    providerId?: number,
    actualDuration?: number,
    telephone?: string,
    recurringAppointmentId?: number,
    providerAppointmentCancelInfo?: TProviderAppointmentCancelInfo,
    relationship?: string,
    providerAppointmentBillings?: TProviderAppointmentBilling[],
};

export enum ERepeatType {
    DOES_NOT_REPEAT = 0,
    DAILY = 1,
    WEEKLY_ON_WEEKDAY = 2,
    MONTHLY_ON_FIRST_DAY = 3,
    MONTHLY_ON_DATE = 4,
    EVERY_WEEKDAY = 5,
}

export type TServerCalendarBlockerEventDetail = {
    id?: number,
    color?: string,
    providerId?: number,
    description?: string,
    title: string;// "Vacation-test-30-23",
    startAt: string;// "2025-03-29T09:00:00",
    endAt: string;//"2025-03-29T11:30:00",
    duration?: number,
    isAllDay: boolean,
    repeatType?: ERepeatType,
    isDeclineAppointment: boolean,
    messageToPatient?: string,
    repeatDesc?: string,
    repeatEndDate?: string,
    repeatDayOfWeek?: string,
    repeatDayOfMonth?: string,
    repeatWeekOfMonth?: string,
    recurrenceRule?: string,
    timezone?: string,
    isSample?: boolean,
};

export type TServerSimpleCalendarEventList = {
    appointmentList: TServerSimpleCalendarEvent[],
    blockerList: TServerSimpleCalendarEvent[],
    googleList: TServerSimpleCalendarEvent[],
};

export enum EProvicerCancelReasonLabel {
    SCHEDULE_CONFLICTS = 'Schedule conflicts',
    MISMATCH_WITH_SCOPE = 'Mismatch with scope/ Medication request',
    INSURANCE_MISMATCH = 'Insurance mismatch',
    OUTSTANDING_PAYMENTS = 'Outstanding payments',
    INCOMPLETE_PATIENT_INFORMATION = 'Incomplete patient information',
    OTHER_REASONS = 'Other reasons',
}

export enum EPatientCancelReasonLabel {
    PATIENT_HAS_SCHEDULE_CONFLICTS = 'Patient has schedule conflicts',
    PATIENT_DOES_NOT_HAVE_A_CREDIT_CARD_ON_FILE = "Patient doesn't have a credit card on file",
    PATIENT_IS_IRRESPONSIVE = 'Patient is irresponsive',
    PATIENT_WANTS_TO_FIND_ANOTHER = 'Patient wants to find / found another provider',
    PATIENT_WANTS_AN_EARLIER_APPOINTMENT = 'Patient wants an earlier appointment',
    PATIENT_DOES_NOT_HAVE_THE_INSURANCE_THAT_I_ACCEPT = "Patient doesn't have the insurance that I accept",
    OTHER_REASONS = 'Other reasons',
}
//枚举：ONLY_REMIND_PATIENT 是发邮件提醒 、DIRECT_UPDATE_TIME 更新时间
export enum ERescheduledAction {
    ONLY_REMIND_PATIENT = 'ONLY_REMIND_PATIENT',
    DIRECT_UPDATE_TIME = 'DIRECT_UPDATE_TIME',
    NEW_APPOINTMENT = 'NEW_APPOINTMENT',
}
